const row1 = ['LinkedIn', 'Indeed', 'Glassdoor', 'Google Jobs', 'Rozee.pk', 'Naukri.com', 'Bayt.com'];
const row2 = ['Ziprecruiter', 'Monster', 'Seek', 'Reed', 'StepStone', 'Wuzzuf', 'Foundit'];
const row3 = ['Jobstreet', 'CareerBuilder', 'SimplyHired', 'Dice', 'AngelList', 'Wellfound', 'Otta'];

function MarqueeRow({ items, reverse = false }: { items: string[]; reverse?: boolean }) {
  const doubled = [...items, ...items];
  return (
    <div className="relative flex overflow-hidden w-full">
      <div
        className={`flex gap-3 ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'}`}
        style={{ width: 'max-content' }}
      >
        {doubled.map((platform, index) => (
          <div
            key={index}
            className="h-11 px-6 bg-gray-100 dark:bg-[#141828] border border-gray-200 dark:border-[#2D3148] rounded-full flex items-center justify-center hover:border-gray-400 dark:hover:border-[#6366F1] transition-colors duration-200 cursor-pointer flex-shrink-0"
          >
            <span className="text-gray-600 dark:text-[#F8FAFC] text-sm font-medium whitespace-nowrap">{platform}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function SocialProof() {
  return (
    <section className="py-16 border-t border-gray-200 dark:border-[#2D3148] bg-white dark:bg-[#0A0E1A] overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6">
        <h2 className="text-center text-gray-500 dark:text-[#94A3B8] text-base font-medium mb-10">
          Works with every major job platform
        </h2>
      </div>

      <div className="relative flex flex-col gap-3">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white dark:from-[#0A0E1A] to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white dark:from-[#0A0E1A] to-transparent z-10 pointer-events-none"></div>

        <MarqueeRow items={row1} reverse={false} />
        <MarqueeRow items={row2} reverse={true} />
        <MarqueeRow items={row3} reverse={false} />
      </div>
    </section>
  );
}
